import type { RootState } from '@/store';

export const selectCertificados = (state: RootState) => state.certificadosArbitrais.items;
export const selectCertificadosLoading = (state: RootState) => state.certificadosArbitrais.loading;
export const selectCertificadosError = (state: RootState) => state.certificadosArbitrais.error;
export const selectCertificadoAcessos = (state: RootState) =>
  state.certificadosArbitrais.certificadoAcessos;
export const selectCertificadoAcessosLoading = (state: RootState) =>
  state.certificadosArbitrais.certificadoAcessosLoading;
export const selectCertificadoAcessosError = (state: RootState) =>
  state.certificadosArbitrais.certificadoAcessosError;
export const selectCertificadoAcessosPdfBaixando = (state: RootState) =>
  state.certificadosArbitrais.certificadoAcessosPdfBaixando;
